<template>
  <div>
    <ImpressaoModal
      header="Atestado"
      ref="modalAtestado"
      size="lg"
      :pageSelect="true"
      @acao="imprimirAtestado"
      @changedata="attPageSize"
      @remover="remover()"
      idModal="atestado"
      :poderemover="id_atestado ? true : false"
      :acao="!id_anamnese ? 'Imprimir' : ( ( id_anamnese && !id_atestado ) ? 'Incluir' : 'Atualizar' ) + ( videoaberto ? '' : ' e Imprimir' )"
    >
      <!-- <div class="modal fade" id="atestadoModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog2 modal-lg" role="document">
        <div class="modal-content modal-content2">
          <div class="modal-header">
            <span>Atestado</span>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
      </div>-->
      <div>
        <az-input
          label="CID"
          sizing="sm"
          type="autocomplete"
          optionsMode="aql"
          service="cids.index"
          optionsDisplay="search"
          v-model="cid"
          class="mb-3"
          v-if="id_anamnese"
        />
        <div class="form-row">
          <div class="col col-12 col-md-3" v-if="1 == 1 || isPrintMedico">
            <az-input
              label="Data"
              type="date"
              sizing="sm"
              v-model="dtReferencia"
              edicao2="isPrintMedico || isLab" />
          </div>
          <div class="col col-12 col-md-3" v-if="isPrintMedico || isPrintAcompanhante">
            <az-input
              label="Dias de Afastamento"
              type="text"
              sizing="sm"
              v-model="diasAfastamento"
              :edicao="isPrintMedico || isPrintAcompanhante" />
          </div>
          <div class="col col-12 col-md-3" v-if="isPrintPaciente || isPrintAcompanhante">
            <AzInput
              label="Horário de Entrada"
              sizing="sm"
              :edicao="isPrintPaciente || isPrintAcompanhante"
              type="time"
              v-model="horaInicio"
            />
          </div>
          <div class="col col-12 col-md-3" v-if="isPrintPaciente || isPrintAcompanhante">
            <AzInput
              label="Horário de Saída"
              sizing="sm"
              :edicao="isPrintPaciente || isPrintAcompanhante"
              type="time"
              v-model="horaFinal"
            />
          </div>
        </div>

          <!-- Atestado pelo Medico -->
          <div class="form-row" v-if="id_anamnese">
            <div class="col col-12 col-md-4">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkMedico"
                  v-model="isPrintMedico"
                />
                <label class="form-check-label" for="checkMedico">
                  <strong>Atestado Médico</strong>
                </label>
              </div>
            </div>
          </div>
          <div class="row w3-animate-opacity" v-if="isPrintMedico">
            <div class="col col-12">
              <az-input
                label="Texto"
                type="textarea"
                v-model="descricaoAtestadoMedico"
                :edicao="isPrintMedico"
                class="w-100 h-25"
              />
            </div>
          </div>
              
          <!-- Paciente -->

          <div class="d-flex flex-column h-25">

            <hr> 

            <div class="form-row">
                <div class="col col-12 col-md-6">
                    <az-input   
                        sizing="sm"
                        type="checkbox-group"
                        label="Atestado de Comparecimento"
                        v-model="isPrintPaciente" />
                </div>

                <div class="col col-12 col-md-6" v-if="isPrintPaciente && listar_modelos('comparecimento').length">
                    <az-input
                        sizing="sm"
                        type="select"
                        :optionsList="listar_modelos('comparecimento')"
                        optionsDisplay="st_nome"
                        v-model="modelo.comparecimento"
                        @input="selecao_modelo('comparecimento')" />
                </div>
            </div>
            
            <div class="d-flex flex-row justify-content-between w-100" v-if="false">
              <div class="d-flex flex-row w-50">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="checkPaciente"
                    v-model="isPrintPaciente"
                  />
                  <label class="form-check-label" for="checkPaciente">
                    <strong>Atestado de Comparecimento</strong>
                  </label>
                </div>
              </div>
            </div>



            <div v-if="isPrintPaciente" class="w3-animate-opacity">
              <AzInput
                label="Texto"
                type="textarea"
                v-model="descricaoAtestadoPaciente"
                :edicao="isPrintPaciente"
                class="w-30"
              />
            </div>
        
          <!-- Acompanhante -->
          <div class="d-flex flex-column h-25">

            <hr> 

            <div class="form-row">
                <div class="col col-12 col-md-6">
                    <az-input   
                        sizing="sm"
                        type="checkbox-group"
                        label="Atestado de Acompanhante"
                        v-model="isPrintAcompanhante" />
                </div>

                <div class="col col-12 col-md-6" v-if="isPrintAcompanhante && listar_modelos('acompanhante').length">
                    <az-input
                        sizing="sm"
                        type="select"
                        :optionsList="listar_modelos('acompanhante')"
                        optionsDisplay="st_nome"
                        v-model="modelo.acompanhante"
                        @input="selecao_modelo('acompanhante')" />
                </div>
            </div>

            <div class="d-flex flex-row" v-if="false">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="checkAcompanhante" v-model="isPrintAcompanhante" />
                    <label class="form-check-label" for="checkAcompanhante">
                        <strong>Atestado de Acompanhante</strong>
                    </label>
                </div>
            </div>

            <div v-show="isPrintAcompanhante == true">
              <div class="form-row">
                <div class="col col-12" :class="acomp_dias ? 'col-md-9' : ''">
                    <az-input
                        sizing="sm"
                        label="Nome do acompanhante"
                        type="text"
                        v-model="nomeAcompanhante"
                        :edicao="isPrintAcompanhante" />
                </div>

                <div class="col col-12 col-md-3" v-if="acomp_dias">
                    <az-input
                        label="Dias de Afastamento"
                        type="text"
                        sizing="sm"
                        v-model="diasAfastamento" />
                </div>
              </div>

              <div class="row mb-2" v-if="isPrintAcompanhante && id_anamnese">
                <div class="col col-12">
                    <az-input
                        sizing="sm"
                        label="Atestado do acompanhante para o período de afastamento"
                        type="checkbox-group"
                        v-model="acomp_dias"
                        @click="refresh_acomp_dias()" />
                </div>
             </div>

              <div>
                <AzInput
                  label="Texto"
                  type="textarea"
                  v-model="descricaoAtestadoAcompanhante"
                  :edicao="isPrintAcompanhante"
                />
              </div>
            </div>
          </div>

          <!-- <div v-if="unidade">{{unidade}}</div> -->
          <div id="impressaoAtestado" v-show="false">
            <div v-if="isPrintMedico">
              <PrintAtestado
                :texto="descricaoAtestadoMedico"
                :marcacao="marcacao"
                :cid="cid ? cid.st_codigo : ''"
                :pageSize="pageSize"
                type="medico"
                :unidade="unidade"
                :medico="medico"
              />
            </div>
            <div v-if="isPrintPaciente">
              <PrintAtestado
                :texto="descricaoAtestadoPaciente"
                :marcacao="marcacao"
                :cid="cid ? cid.st_codigo : ''"
                :pageSize="pageSize"
                type="paciente"
                :unidade="unidade"
                :medico="medico"
              />
            </div>
            <div v-if="isPrintAcompanhante">
              <PrintAtestado
                :texto="descricaoAtestadoAcompanhante"
                :marcacao="marcacao"
                :cid="cid ? cid.st_codigo : ''"
                :pageSize="pageSize"
                type="acompanhante"
                :unidade="unidade"
                :medico="medico"
              />
            </div>
          </div>
        </div>
      </div>
      
    </ImpressaoModal>
  </div>
</template>

<script>
//import * as moment from "moment";
import _ from "lodash";
import $ from 'jquery';

import PrintAtestado from "./ImpressaoAtestado";
import ImpressaoModal from "../../relatorios/shared/ModalImpressao";
import * as moment from 'moment';
import AzInput from '../forms/AzInput.vue';

export default {
  data() {
    return {
      id_atestado: null,
      dtReferencia: "", 
      horaInicio: "",
      horaFinal: "",
      nomeAcompanhante: "",
      descricaoAtestadoPaciente: "",
      descricaoAtestadoAcompanhante:
        "Atesto para os devidos fins, que o(a) Sr.(a) #Acompanhante compareceu hoje nesta clínica acompanhando o(a) paciente #Paciente em sua consulta médica. ",
      descricaoAtestadoMedico: "",
      // "Atesto para o devido fim que o(a) Sr.(a) " +
      // this.pacienteNome +
      // ", encontra-se sob os meus cuidados médicos profissionais, estando impossibilitado(a) de frequentar o trabalho no período mínimo de #Dias de Afastamento# dia(s), a partir da data de hoje.",
      diasAfastamento: "",
      marcacao: {},
      cid: "",
      pageSize: "A5",

      isPrintAcompanhante: false,
      isPrintPaciente: true,
      isPrintMedico: false,

      videoaberto: false,

      unidade: { item: [] },
      medico: null, 

      id_marcacao: null, 
      acomp_dias: false, 
      abrindo: false, 

      modelos: false, 
      modelo_comparecimento: "", 

      modelo: { 
        comparecimento: "", 
        acompanhante: "", 
      }, 
    };
  },
  props: ["id_anamnese"],
  methods: {
    listar_modelos (classe) { 
        if ( !this.modelos || !this.modelos.length ) { 
            return []; 
        }

        return this.modelos.filter(item => item.js_classes && item.js_classes.includes(classe));
    },

    refresh_acomp_dias () { 
        this.acomp_dias = !this.acomp_dias;

        this.$nextTick(() => { 
            this.refresh_texto_acompanhante();
        });
    },

    refresh_texto_acompanhante() { 
        if (this.pacienteNome) { 

            if ( this.modelo && this.modelo.acompanhante && this.modelo.acompanhante.st_descricao ) { 

                let texto = this.modelo.acompanhante.st_descricao; 

                if ( this.nomeAcompanhante ) { 
                    texto = texto.replaceAll('#Acompanhante', this.nomeAcompanhante);
                }

                if ( this.diasAfastamento ) { 
                    texto = texto.replaceAll('#Dias', this.diasAfastamento);
                }

                this.descricaoAtestadoAcompanhante = texto; 

            } else { 

                if ( this.acomp_dias ) { 

                    this.descricaoAtestadoAcompanhante =
                        "Atesto para os devidos fins, que o(a) Sr.(a) " +
                        this.nomeAcompanhante +
                        " necessita de " + this.diasAfastamento + " dias de afastamento de suas atividades para acompanhar o(a) paciente " +
                        this.pacienteNome +
                        " submetido(a) a procedimento médico. "

                } else { 

                    this.descricaoAtestadoAcompanhante =
                        "Atesto para os devidos fins, que o(a) Sr.(a) " +
                        this.nomeAcompanhante +
                        " compareceu hoje nesta clínica acompanhando o(a) paciente Sr(a). " +
                        this.pacienteNome +
                        " em sua consulta médica. ";  

                }

            }

        }

    },

    retirar_ponto_final (texto) { 
      if ( !texto )
        return '';

      texto = texto.trim();

      if ( texto.substring(texto.length - 1) == '.' ) { 
        texto = texto.substring(0, texto.length - 1);
      }
      
      return texto;
    },

    remover () { 
      if ( !confirm('Confirma remover esse registro?') )
        return;

      this.$util.atualizar(this, { 
        service: 'pep',
        func: 'item_remover', 
        dados: { 
          model_type: 'atestado',
          model_id: this.id_atestado,
        },
        callback: () => { 
          $('.modal').modal("hide");
          this.$emit('refresh', null);
        }
      });
    },

    imprimirAtestado(dados) {
      let isError = false;
      let summErr = "";
      let detailErr = "";

      if (
        !(
          this.isPrintAcompanhante ||
          this.isPrintMedico ||
          this.isPrintPaciente
        )
      ) {
        summErr = "Não foi possível gerar atestado.";
        detailErr = "Nenhum Atestado Selecionado";
        isError = true;
      }

      if (this.isPrintMedico && !this.diasAfastamento) {
        summErr = "Não foi possível gerar o atestado médico.";
        detailErr = "Campo de dias nao especificado";
        isError = true;
      }

      if (this.isPrintPaciente && this.isHorarioEmpty()) {
        summErr = "Não foi possível gerar o atestado de comparecimento.";
        detailErr = "Horário não especificado";
        isError = true;
      }

      if (
        this.isPrintAcompanhante &&
        !(this.nomeAcompanhante && !this.isHorarioEmpty())
      ) {
        summErr = "Não foi possível gerar o atestado de acompanhante.";
        if (this.isHorarioEmpty()) detailErr = "Horário não especificado";
        else detailErr = "Nome do acompanhante não especificado";
        isError = true;
      }

      if (isError) {
        this.$toast.add({
          severity: "error",
          summary: summErr,
          detail: detailErr,
          life: 3000
        });
        return;
      }

      //

      if ( this.id_anamnese ) { 

        this.$util.atualizar(this, { 
          service: 'atestados',
          dados: { 
            id_atestado: this.id_atestado, 
            id_anamnese: this.id_anamnese,
            dt_referencia: this.dtReferencia, // this.isPrintMedico ? this.dtReferencia : null, 
            hr_inicio: ( this.isPrintAcompanhante || this.isPrintPaciente ) ? this.horaInicio : null,
            hr_fim: ( this.isPrintAcompanhante || this.isPrintPaciente ) ? this.horaFinal : null,
            id_cid: this.cid ? this.cid.id_cid : null, 
            int_dias_afastamento: this.diasAfastamento, 
            st_nome_acompanhante: this.isPrintAcompanhante ? this.nomeAcompanhante : null, 
            st_descricao_medico: this.isPrintMedico ? this.descricaoAtestadoMedico : null, 
            st_descricao_comparecimento: this.isPrintPaciente ? this.descricaoAtestadoPaciente : null, 
            st_descricao_acompanhante: this.isPrintAcompanhante ? this.descricaoAtestadoAcompanhante : null, 
            fl_acomp_dias: this.acomp_dias ? true : false,
          }, 
          modal: "modalAtestado",
          callback: res => { 
            this.imprimir(res);
            this.$emit('refresh');
          }
        });

      } else { 

        this.imprimir(dados);

      }

      
    },
    imprimir (dados) { 
      $('.modal').modal('hide');
      
      if ( this.videoaberto )
        return;

      if ( dados.id_atestado ) { 

        this.$util.print_preview('imprimir/atestado/' + dados.id_atestado, true);
        
      } else { 

        this.$util.print_preview(
          'imprimir/atestado_recepcao/', 
          false, 
          { 
            id_atestado: null, 
            id_anamnese: this.id_anamnese,
            id_marcacao: this.id_marcacao, 
            dt_referencia: this.dtReferencia, // this.isPrintMedico ? this.dtReferencia : null, 
            hr_inicio: ( this.isPrintAcompanhante || this.isPrintPaciente ) ? this.horaInicio : null,
            hr_fim: ( this.isPrintAcompanhante || this.isPrintPaciente ) ? this.horaFinal : null,
            id_cid: this.cid ? this.cid.id_cid : null, 
            int_dias_afastamento: this.isPrintMedico ? this.diasAfastamento : null, 
            st_nome_acompanhante: this.isPrintAcompanhante ? this.nomeAcompanhante : null, 
            st_descricao_medico: this.isPrintMedico ? this.descricaoAtestadoMedico : null, 
            st_descricao_comparecimento: this.isPrintPaciente ? 
              ( this.retirar_ponto_final(this.descricaoAtestadoPaciente) + ', das ' + this.horaInicio + ' às ' + this.horaFinal + '.') : null, 
            st_descricao_acompanhante: this.isPrintAcompanhante ? 
              ( this.retirar_ponto_final(this.descricaoAtestadoAcompanhante) + ', das ' + this.horaInicio + ' às ' + this.horaFinal + '.') : null,  
            id_medico: this.marcacao.id_medico,
            papel: this.$util.getCookie('page-size'),
            id_unidade_operacao: this.marcacao.id_unidade_operacao, 
            fl_acomp_dias: this.acomp_dias ? true : false,
          }
        );

        /*

        let configPrintAtestado;
        this.pageSize = dados.pageSize;
        this.$util.setCookie('page-size', this.pageSize, 365);

        if (this.pageSize == "A5") {
          configPrintAtestado = {
            name: "_blank",
            specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=no"],
            styles: [
              "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
              "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
              "https://api.klingo.app/css/estiloa5.css" 
            ]
          };
        } else if (this.pageSize == "A4") {
          configPrintAtestado = {
            name: "_blank",
            specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=no"],
            styles: [
              "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
              "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
              "https://api.klingo.app/css/estiloa4.css"
            ]
          };
        }

        this.descricaoAtestadoPaciente += " " + this.textHorario;
        this.descricaoAtestadoAcompanhante += " " + this.textHorario;
        this.$nextTick(() => {
          this.$htmlToPaper("impressaoAtestado", configPrintAtestado, () => {
            this.resetModal();
          });
        });
        */

      }
    },

    selecao_modelo(tipo) {
        this.$nextTick(() => { 
            if ( tipo == 'comparecimento' ) { 
                this.descricaoAtestadoPaciente = _.get(this.modelo, tipo + '.st_descricao'); 
            } else if ( tipo == 'acompanhante' ) { 
                this.refresh_texto_acompanhante(); 
            }
        });
    },

    abrirModalAtestado(marcacao, atestado = null, impressao = false, horarioSaidaAtual = false) {
      this.medico = null;
      this.modelos = false; 
      this.modelo = { 
        comparecimento: "",
        acompanhante: "", 
      };

      if ( atestado ) { 

        this.abrindo = true; 

        this.$nextTick(() => { 
            this.id_atestado = atestado.id_atestado;
            this.id_marcacao = null;
            this.diasAfastamento = atestado.int_dias_afastamento;
            this.horaInicio = atestado.hr_inicio ? atestado.hr_inicio.substr(0,5) : "";
            this.horaFinal = atestado.hr_fim ? atestado.hr_fim.substr(0,5) : "";
            this.nomeAcompanhante = atestado.st_nome_acompanhante;
            this.descricaoAtestadoPaciente = atestado.st_descricao_comparecimento;
            this.descricaoAtestadoAcompanhante = atestado.st_descricao_acompanhante;
            this.descricaoAtestadoMedico = atestado.st_descricao_medico;
            this.cid = atestado.cid;
            this.isPrintAcompanhante = atestado.atestado_acompanhante;
            this.isPrintPaciente = atestado.atestado_comparecimento;
            this.isPrintMedico = atestado.atestado_medico;
            this.dtReferencia = atestado.dt_referencia;
            this.acomp_dias = atestado.fl_acomp_dias ? true : false;

            this.abrindo = false; 
        });

      } else { 

        this.id_atestado = null;
        this.id_marcacao = marcacao ? marcacao.id_marcacao : null;
        this.dtReferencia = marcacao 
          ? ( marcacao.dt_checkin 
              ? marcacao.dt_checkin.substr(0,10) 
              : marcacao.dt_inicio.substr(0,10) 
          )
          : this.$util.hoje();
        this.diasAfastamento = "";
        this.horaInicio = "";
        this.horaFinal = horarioSaidaAtual ? moment().format("HH:mm") : "";
        this.nomeAcompanhante = "";
        this.cid = ( marcacao && marcacao.atendimento ) ? marcacao.cid : "";
        this.acomp_dias = false;
      }

      this.videoaberto = $('#video-aberto').length ? true : false;
      
      this.pageSize = this.$util.getCookie('page-size');
      this.marcacao = marcacao;

      this.initialState(atestado);

      if ( marcacao && ( this.modelos === false ) && !this.id_anamnese ) { 
        this.$util.loadItem(this, { 
          service: 'atestados',
          func: 'modelos',
          parms: { 
            id_marcacao: marcacao.id_marcacao, 
          }
        })
        .then(res => { 
            this.modelos = res.lista; 
            console.log('mod-atest', res);
        });
      }

      if ( atestado ) { 
        this.isPrintAcompanhante = atestado.atestado_acompanhante;
        this.isPrintPaciente = atestado.atestado_comparecimento;
        this.isPrintMedico = atestado.atestado_medico;
      }
      
      if ( !impressao ) { 
        this.$refs.modalAtestado.abrirModalImpressao();
      } else { 
        this.imprimirAtestado({ 
          pageSize: this.$util.getCookie('page-size') ? this.$util.getCookie('page-size') : 'A4',
          salvarKit: false,
          impressaoAgrupada: false,
        });
      }

      this.$util.loadItem(this, { 
        service:'medicos',
        id: marcacao.id_medico,
        with: ['medico_unidade','medico_especialidade.especialidade','pessoa.cadastro','conselho','estado_conselho']
      })
      .then(res => { 
        this.medico = res;
      });
    },
    isHorarioEmpty() {
      return !(this.horaInicio && this.horaFinal);
    },
    resetModal() {
      this.initialState();
    },
    initialState() {
      if (this.marcacao.paciente && this.marcacao.paciente.st_nome) {

        let texto_consulta = 'consulta médica ';
        let texto_consulta_comp = " em sua consulta médica. ";
        let texto_local_acomp = "nesta clínica ";

        if ( this.marcacao.procedimento && this.marcacao.procedimento.id_classe_procedimento == 4 ) { 
          texto_consulta = 'realizar exames.';
          texto_consulta_comp = " para realização de exames.";
          texto_local_acomp = ""; 
        } else if ( this.marcacao.procedimento && this.marcacao.procedimento.id_classe_procedimento == 17 && this.marcacao.procedimento.especialidade ) { 
          texto_consulta = 'atendimento de ' + this.marcacao.procedimento.especialidade.search.toLowerCase() + '.';
          texto_consulta_comp = " para atendimento de " + this.marcacao.procedimento.especialidade.search.toLowerCase() + ".";
          texto_local_acomp = ""; 
        }

        this.descricaoAtestadoPaciente =
          "Atesto para os devidos fins, que o(a) Sr.(a) " +
          this.marcacao.paciente.st_nome +
          " compareceu hoje para " + texto_consulta;

        this.descricaoAtestadoAcompanhante =
          "Atesto para os devidos fins, que o(a) Sr.(a) #Acompanhante compareceu hoje " + texto_local_acomp + "acompanhando o(a) paciente Sr(a). " +
          this.pacienteNome + texto_consulta_comp;

        this.descricaoAtestadoMedico =
          "Atesto para o devido fim que o(a) Sr.(a) " +
          this.pacienteNome +
          ", encontra-se sob os meus cuidados médicos profissionais, estando impossibilitado(a) de frequentar o trabalho no período mínimo de #Dias de Afastamento# dia(s), a partir da data de hoje.";

      } else { 

        this.descricaoAtestadoPaciente = "O paciente X compareceu no hospital.";

      }

      //console.log('at', this.marcacao);

      if ( !this.horaInicio ) { 
        this.horaInicio = this.marcacao.atendimento 
          ? ( this.marcacao.dt_checkin 
            ? this.marcacao.dt_checkin.substr(11,5)
            : this.marcacao.atendimento.dt_inicio.substr(11,5) 
          )
          : "";
      }

      if ( !this.horaFinal ) { 
        this.horaFinal = ( this.marcacao.atendimento && this.marcacao.atendimento.progresso_atendimentos.length )
          ? this.marcacao.atendimento.progresso_atendimentos.slice(-1)[0].dt_conclusao.substr(11,5)
          : "";
      }

      if (this.diasAfastamento) {
        this.descricaoAtestadoMedico =
          "Atesto para o devido fim que o(a) Sr.(a) " +
          this.pacienteNome +
          ", encontra-se sob os meus cuidados médicos profissionais, estando impossibilitado(a) de frequentar o trabalho no período mínimo de " +
          this.diasAfastamento +
          " dia(s), a partir da data de hoje.";
      }
      if (this.id_anamnese) {
        this.isPrintMedico = true;
        this.isPrintPaciente = false;
        this.isPrintAcompanhante = false;
      }
    },
    attPageSize(dados) {
      this.pageSize = dados.pageSize;
      this.$forceUpdate();
    },
    getUnidade() {
      // this.$util
      //   .loadItem(this, {
      //     service: "unidades",
      //     id: this.marcacao.id_unidade
      //   })
      //   .then(res => {
      //     this.unidade = res;
      //     console.log("unidade", res);
      //   });
      this.unidade = this.$store.state.unidade;
    }
  },
  computed: {
    pacienteNome() {
      return this.marcacao &&
        this.marcacao.paciente &&
        this.marcacao.paciente.st_nome
        ? this.marcacao.paciente.st_nome
        : null;
    },
    textHorario() {
      if (!this.isHorarioEmpty())
        return "de " + this.horaInicio + " à " + this.horaFinal + ".";
      return "";
    },
    isLab() { 
      return ( this.marcacao &&
        this.marcacao.procedimento &&
        this.marcacao.procedimento.id_especialidade == 2 ) 
        ? true
        : false;
    },
  },
  watch: {
    nomeAcompanhante: function () {
        if ( this.abrindo ) 
            return;

        this.refresh_texto_acompanhante();
        /*
        if (this.pacienteNome)
            this.descricaoAtestadoAcompanhante =
                "Atesto para os devidos fins, que o(a) Sr.(a) " +
                newNomeAcompanhante +
                " compareceu hoje nesta clínica acompanhando o(a) paciente Sr(a). " +
                this.pacienteNome +
                " em sua consulta médica. ";
          */
    },

    diasAfastamento(diasAfastamento) {
        if ( this.abrindo ) 
            return;

        this.descricaoAtestadoMedico =
            "Atesto para o devido fim que o(a) Sr.(a) " +
            this.pacienteNome +
            ", encontra-se sob os meus cuidados médicos profissionais, estando impossibilitado(a) de frequentar o trabalho no período mínimo de " +
            diasAfastamento +
            " dia(s), a partir da data de hoje.";

        if ( this.acomp_dias ) { 
            this.refresh_texto_acompanhante();
        }
    },

    marcacao() {
      this.$nextTick(() => {
        this.getUnidade();
      });
    }
  },
  mounted() {
    this.initialState();
  },
  components: {
    AzInput,
    PrintAtestado,
    ImpressaoModal
  }
};
</script>

<style></style>
